import * as React from 'react';
import LiveRegion from 'live-region';

export const useDocumentTitle = (title, hideFranchisorName = false) => {
  const region = React.useMemo(() => new LiveRegion(), []);

  const franchisorName = 'Youth Athletes United';

  React.useEffect(() => {
    if (!title) {
      document.title = franchisorName;
    } else {
      document.title = `${title}${
        !hideFranchisorName ? ` | ${franchisorName}` : ''
      }`;
      region.announce(`Page: ${document.title}`);
    }

    return () => {
      document.title = franchisorName;
      try {
        region.destroy();
      } catch (error) {
        //
      }
    };
  }, [title, region, franchisorName, hideFranchisorName]);
};
